// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__A6VcJ","left":"StickyBox_left__3RtZi","right":"StickyBox_right__ySWrI"};